import React, { useEffect, useState } from 'react'
import { makeStyles, createStyles, Typography } from '@material-ui/core'
import HelpIcon from '@material-ui/icons/Help'
import clsx from 'clsx'
import TextField from '../TextField/TextField'
import CMSText, { prismicText } from '../Global/CMSText'

type Tprops = {
  doc: any
  t: any
  setGlobalReview?: any
  handleMessage?: any
  message?: string
}

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      background: theme.extraColors.greyLight,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(3, 4, 2),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(2, 2, 1),
      },
    },
    rowCenter: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    rowLayout: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        gap: theme.spacing(1),
      },
    },
    spaceLeft: {
      marginLeft: theme.spacing(2),
    },
    note: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 36,
      height: 36,
      lineHeight: 1,
      textAlign: 'center',
      border: `${theme.palette.common.black} solid 1px`,
      borderRadius: '50%',
      margin: theme.spacing(0.5),
      cursor: 'pointer',
      [theme.breakpoints.down('md')]: {
        width: 24,
        height: 24,
        margin: theme.spacing(0.25),
      },
    },
    noteActive: {
      border: `${theme.palette.secondary.main} solid 2px`,
      color: theme.palette.secondary.main,
      fontWeight: 700,
    },
    alignCenter: {
      textAlign: 'center',
    },
    textArea: {
      '& .input': {
        backgroundColor: theme.palette.common.white,
        '& .MuiInput-root': {
          position: 'initial',
          width: '100%',
        },
        '& .MuiInput-underline:before': {
          display: 'none',
        },
      },
    },
    textAreaContainer: {},
  })
)

const GlobalSatisfactionForm = ({
  doc,
  t,
  setGlobalReview,
  handleMessage,
  message,
}: Tprops) => {
  const classes = useStyles()
  const [notes, setNotes] = useState([])

  const noteArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

  const handleNotes = (idQuestion, note) => {
    const arrayNotes = [...notes]
    arrayNotes[idQuestion].note = note
    setNotes(arrayNotes)
    setGlobalReview(arrayNotes)
  }

  useEffect(() => {
    const array = [...notes]
    doc?.data?.questions?.map((question, index) => {
      array.push({ note: 5, id: index })
    })
    setNotes(array)
  }, [])

  return (
    <div className={classes.root}>
      <div className={classes.rowCenter}>
        <HelpIcon />
        <div className={classes.spaceLeft}>
          <Typography variant={'h3'}>
            <CMSText
              asText
              data={doc?.data?.main_title}
              defaultText={t('texts:customer_survey:main_title')}
            />
          </Typography>
          <Typography variant={'caption'}>
            <CMSText
              asText
              data={doc?.data?.subtitle}
              defaultText={t('texts:customer_survey:subtitle')}
            />
          </Typography>
        </div>
      </div>
      <div className={classes.rowLayout}>
        {doc?.data?.questions?.map((question, index) => {
          return (
            <div key={index}>
              <Typography variant={'caption'} component={'p'}>
                {prismicText(question?.question)}
              </Typography>
              <div className={classes.rowCenter}>
                {noteArray?.map((note, key) => {
                  return (
                    <div
                      key={key}
                      className={clsx(
                        classes.note,
                        notes[index]?.note === note && classes.noteActive
                      )}
                      onClick={() => handleNotes(index, note)}
                    >
                      {note}
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
      </div>
      <div className={classes.textAreaContainer}>
        <Typography variant="caption">
          <CMSText
            asText
            data={doc?.data?.let_a_message}
            defaultText={t('texts:customer_survey:let_a_message')}
          />
        </Typography>
        <TextField
          multiline
          textArea
          rows={4}
          rowsMax={4}
          type={'textarea'}
          name={'message'}
          value={message}
          onChange={handleMessage}
          className={clsx('textarea', classes.textArea)}
        />
      </div>
    </div>
  )
}

export default GlobalSatisfactionForm
